var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustchatlogo = function SvgTrustchatlogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.885 0h-9.77C5.435 0 0 5.378 0 11.988c0 6.61 5.435 11.987 12.115 11.987h4.583v-6.106h-4.583c-3.277 0-5.943-2.639-5.943-5.88 0-3.243 2.666-5.881 5.943-5.881h9.77c3.277 0 5.943 2.638 5.943 5.88v.102a5.84 5.84 0 0 1-2.15 4.527l-9.094 7.463h.017V32l13.018-10.682A11.905 11.905 0 0 0 34 12.09v-.102C34 5.378 28.565 0 21.885 0"
  })));
};
export { SvgTrustchatlogo as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTNiOTFmMTMyMjI4ZDhkNzk2MGI0ZWNkMWVlMWQ1ODEuc3ZnIjs=";